<ion-item [class]="color" [class.horizontal-margin]="horizontalMargin">
    <div class="icon" *ngIf="icon">
        <ion-icon [class]="'icon '+icon" slot="start"></ion-icon>
    </div>
    <div>
        <div class="header" *ngIf="headerLeft || headerRight">
            <h3 class="content-title ion-no-margin">{{headerLeft | translate}}</h3>
            <h3 class="dropdown ion-no-margin">{{headerRight | translate}}</h3>
        </div>
        <p class="paragraph-13 ion-no-margin">
            {{text | translate}}
        </p>
        <div class="late-cancellation" *ngIf="lateCancellation">
            <h3 class="content-title ion-no-margin">{{'settings.payment.lateCancellationFee' | translate}}</h3>
            <h3 class="card-title ion-no-margin">{{20 |currency:'USD':true:'1.0'}}</h3>
        </div>
    </div>
</ion-item>
